.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--zumpo-space-24);
  min-height: 104px;
}

.home {
  border-radius: var(--zumpo-radius-8);
  color: inherit;
  text-decoration: none;
}

.nav {
  display: flex;
  align-items: center;
  gap: var(--zumpo-space-32);
}

.links {
  display: flex;
  align-items: center;
  gap: var(--zumpo-space-32);
  margin: 0;
  padding: 0;
  list-style: none;
}

.link {
  border-radius: var(--zumpo-radius-8);
  color: var(--zumpo-muted);
  font: var(--zumpo-text-label);
  letter-spacing: var(--zumpo-text-label-tracking);
  text-decoration: none;
}

.link[aria-current='page'] {
  color: var(--zumpo-ink);
}

@media (hover: hover) {
  .link:hover {
    color: var(--zumpo-ink);
  }
}

.home:focus-visible,
.link:focus-visible {
  outline: var(--focus-ring) solid var(--zumpo-ink);
  outline-offset: var(--focus-ring);
}

/* The avatar as the name menu's trigger: a round button, the avatar's size. */
.viewerButton {
  position: relative;
  display: inline-flex;
  padding: 0;
  border: 0;
  border-radius: var(--zumpo-radius-999);
  background: none;
  cursor: pointer;
}

/* The avatar takes a tap from 6 px around it: 44 px on a phone, where it is
   drawn 32, the size a thumb needs. */
.viewerButton::before {
  position: absolute;
  inset: calc(-1 * var(--zumpo-space-6));
  content: '';
}

.viewerButton:focus-visible {
  outline: var(--focus-ring) solid var(--zumpo-ink);
  outline-offset: var(--focus-ring);
}

@media (max-width: 640px) {
  .header {
    min-height: 48px;
  }

  .nav {
    gap: var(--zumpo-space-8);
  }

  .links {
    display: none;
  }

  .viewer {
    --zumpo-avatar-size: 32px;
  }
}
